module.exports = __webpack_public_path__ + "img/dzjqr-phone.110e333f.png";